import { createFormConfig, ValidationRules } from "helpers/createFormConfig";
import { PlateformeFormFieldNames } from "./PlateformeFormFieldNames";
import { ThemeFormValues } from "./ThemeFormValues";
import { themeValidationRules } from "./themeValidationRules";

export const initThemeDefaultValues = {
    // Couleurs de repli de l'app (createInitMiddleware) : un thème valide par
    // défaut — sinon le submit est bloqué par des erreurs dans la section repliée.
    [PlateformeFormFieldNames.PrimaryColor]: '#51A0AA',
    [PlateformeFormFieldNames.SecondaryColor]: '#EC7033',
    [PlateformeFormFieldNames.BackgroundColor]: '#FFFFFF',
    [PlateformeFormFieldNames.SurfaceColor]: '#F5F5F5',
    [PlateformeFormFieldNames.AccentColor]: '#9C27B0',
    [PlateformeFormFieldNames.ErrorColor]: '#F44336',
    [PlateformeFormFieldNames.SuccessColor]: '#4CAF50',
    [PlateformeFormFieldNames.WarningColor]: '#FF9800',
    [PlateformeFormFieldNames.InfoColor]: '#2196F3',
    // Police de l'app, chargée via Google Fonts — sélectionnée par défaut.
    [PlateformeFormFieldNames.FontFamily]: 'Lato',
}

const themeFormConfig = createFormConfig<ThemeFormValues>(
  themeValidationRules as ValidationRules<keyof ThemeFormValues>,
  {
    ...initThemeDefaultValues
  }
);

export { themeFormConfig };
